<template>
  	<!-- Page Content Wrapper -->
  	<div id="page-content-wrapper" class="admin-content-area cl">
    	<div class="container-fluid xyz location-listing">
            <!-- <customer-audit-inventory></customer-audit-inventory> -->
      		<div class="page-header-top-container" style="position: fixed;">
        		<div class="page-name mb-1" style="width:100%">My Orders</div>
                <!-- <template v-if="!isShowDateRangePicker">
				    <button type="submit" v-on:click.prevent="loadInventoryParts(true)" class="btn btn-primary waves-effect pull-right">Export</button>	
				</template>
				<template v-else> -->
				<div class="page-name" style="width:100%">
                    <div class="row">
                        <div class="col-md-6">
                            <VueCtkDateTimePicker v-model="date_picker_dates"
                                range
                                :only-date="date_picker_options.onlyDate"
                                :only-time="false"
                                :output-format="date_picker_options.outputFormat"
                                :format="date_picker_options.inputFormat"
                                :formatted="date_picker_options.formatted"
                                :noClearButton="date_picker_options.noClearButton"
                                :custom-shortcuts="date_picker_options.customShortcuts"
                                @input="changeDatePickerDate()"
                                :maxDate="date_picker_options.maxDate"
                            ></VueCtkDateTimePicker>
					    </div>
					    <div class="col-md-6">
                            <button type="submit" v-on:click.prevent="loadInventoryParts(true)" class="btn btn-primary waves-effect pull-right">Export</button>
                            <button type="button" class="btn btn-primary waves-effect pull-right" v-on:click="loadInventoryParts(false)">Apply Filter</button>
                            <button type="button" class="btn btn-primary waves-effect pull-right" v-on:click="clearFilter()">Clear Filter</button>          
                            <button type="submit" id='refreshList' title='Refresh' class="extraFeature btn btn-primary waves-effect pull-right ml-2" v-on:click.prevent="loadInventoryParts(false)">
                                <i class="fa fa-rotate-right" aria-hidden="true"></i>
                            </button>
                        </div>
                    </div>
                </div>
				<!-- </template> -->
      		</div>
      		<!--page content-->
      		<div class="admin-page-content" style="padding-top: 130px;">
        		<label class="policy-text">** Total displayed below does not include Tax and Core Charges</label>
                <div class="contact-grid-container">
                    <div class="row no-margin">
                        <div class="app-filter-good-table-container text-align-placeholder-cutomer-dashboard">
                            <vue-good-table
                                ref="listInventoryPartsTable"
                                mode="remote"
                                title="Order History"
                                @on-page-change="onPageChange"
                                @on-column-filter="onColumnFilter"
                                @on-per-page-change="onPerPageChange"
                                @on-sort-change="onSortChange"
                                @on-selected-rows-change="selectionChanged"
                                :totalRows="totalRecords"
                                :columns="columns"
                                :rows="rows"
                                :row-style-class="rowStyleClassFn"
                                :pagination-options="{
                                    enabled: true,
                                    mode: 'pages',
                                    pageLabel: 'Page',
                                    position: 'both',
                                    perPage: 25,
                                    setCurrentPage: serverParams.setCurrentPage,
                                    perPageDropdown: [25, 50, 100, 200 ,500],
                                    dropdownAllowAll: false,
                                }"
                                :search-options="{
                                    enabled: false,
                                }">

                                <!-- Custome Pagination -->
                                <template slot="pagination-top" slot-scope="props">
                                    <div class="vgt-wrap__footer top-pagination crm">
                                        <div  class="row">
                                            <div class="col-sm-12 col-md-2 PerPage">
                                                <v-select title="Select Per Page"
                                                    v-model="serverParams.perPage"
                                                    @change="changedValueTask"
                                                    @input="changedValueTaskCustomPerPageTask()"
                                                    name="customPerPage"
                                                    id="customPerPage"
                                                    label="text"
                                                    :clearable="false"
                                                    :searchable="false"
                                                    :filterable="false"
                                                    :options="serverParams.perPageDropdown"
                                                    placeholder="Select Per Page">
                                                </v-select>
                                            </div>
                                            <div class="mt-2 col-sm-12 col-md-2 RowsDisplay">
                                                <p class="pageRowCount">{{paginationDisplayRowsTask}} of {{totalRecords}}</p>
                                            </div>
                                            <div class="col-sm-12 col-md-6 Pagination">
                                                <ul class="pagination">
                                                    <li class="FirstPage" title="First Page">
                                                        <template v-if="Number(serverParams.page) == 1">
                                                            <a class="page-link" href="javascript:void(0)">1</a>
                                                        </template>
                                                        <template v-else>
                                                            <a v-on:click="onPerticularPageClickTask(1)" class="page-link" href="javascript:void(0)">1</a>
                                                        </template>
                                                    </li>
                                                    <li class="page-item PreviousPage" title="Previous Page">
                                                        <template v-if="Number(serverParams.page) == 1">
                                                            <a class="page-link" href="javascript:void(0)" tabindex="-1"><i class="fa fa-angle-left"></i></a>
                                                        </template>
                                                        <template v-else>
                                                            <a class="page-link" href="javascript:void(0)" tabindex="-1" v-on:click="onPerticularPageClickTask(Number(serverParams.page)-1)" ><i class="fa fa-angle-left"></i></a>
                                                        </template>
                                                    </li>
                                                    <!--New Implementation-->
                                                    <template v-if="pageNumberListTask() < displayPageTask">
                                                        <template v-for="(n, index) in pageNumberListTask()">
                                                            <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                                <a class="page-link" href="javascript:void(0)">
                                                                    {{n}}
                                                                </a>
                                                            </li>
                                                            <li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                                <a class="page-link" href="javascript:void(0)">
                                                                    {{n}}
                                                                </a>
                                                            </li>
                                                        </template>
                                                    </template>
                                                    <template v-else>
                                                        <!--End New Implementation-->
                                                        <template v-if="Number(serverParams.page) <= pageCompareTask">
                                                            <template v-for="(n, index) in displayPageTask">
                                                                <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                                    <a class="page-link" href="javascript:void(0)">
                                                                        {{n}}
                                                                    </a>
                                                                </li>
                                                                <li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                                    <a class="page-link" href="javascript:void(0)">
                                                                        {{n}}
                                                                    </a>
                                                                </li>
                                                            </template>
                                                        </template>
                                                        <template v-else-if="Number(serverParams.page) >= (pageNumberListTask() - (pageCompareTask-1))">
                                                            <template v-for="(n, index) in pageNumberListTask()">
                                                                <template v-if="n > (pageNumberListTask() - displayPageTask)">
                                                                    <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                                        <a class="page-link" href="javascript:void(0)">
                                                                            {{n}}
                                                                        </a>
                                                                    </li>
                                                                    <li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                                        <a class="page-link" href="javascript:void(0)">
                                                                            {{n}}
                                                                        </a>
                                                                    </li>
                                                                </template>
                                                            </template>
                                                        </template>
                                                        <template v-else>
                                                            <template v-for="(n, index) in pageNumberListTask()" v-if="(n >= (Number(serverParams.page) - (pageCompareTask -1))) && (n <= (Number(serverParams.page) + (pageCompareTask -1)))">
                                                                <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                                    <a class="page-link" href="javascript:void(0)">
                                                                        {{n}}
                                                                    </a>
                                                                </li>
                                                                <li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                                    <a class="page-link" href="javascript:void(0)">
                                                                        {{n}}
                                                                    </a>
                                                                </li>
                                                            </template>
                                                        </template>
                                                    </template>
                                                    <li class="page-item NextPage" title="Next Page">
                                                        <template v-if="Number(serverParams.page) == pageNumberListTask()">
                                                            <a class="page-link" href="javascript:void(0)"><i class="fa fa-angle-right"></i></a>
                                                        </template>
                                                        <template v-else>
                                                            <a class="page-link" href="javascript:void(0)" v-on:click="onPerticularPageClickTask(Number(serverParams.page)+1)"><i class="fa fa-angle-right"></i></a>
                                                        </template>
                                                    </li>
                                                    <li class="LastPage" title="Last Page">
                                                        <template v-if="Number(serverParams.page) == pageNumberListTask()">
                                                            <a class="page-link" href="javascript:void(0)" tabindex="-1">{{pageNumberListTask()}}</a>
                                                        </template>
                                                        <template v-else>
                                                            <a v-on:click="onPerticularPageClickTask(pageNumberListTask())" class="page-link" href="javascript:void(0)" tabindex="-1">{{pageNumberListTask()}}</a>
                                                        </template>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div class="mt-2 col-lg-1 col-md-1 col-sm-2 col-xs-6">
                                                <p class="pageJumpLabel">Page : </p>
                                            </div>
                                            <div class="mt-1 col-lg-1 col-md-1 col-sm-2 col-xs-6">
                                                <input @keyup.enter="jumpToPageInTask" v-model="jumpToPageTask" type="text" class="form-control form-control-sm" name="jumpToPageTask" id="jumpToPageTask" placeholder="Page">
                                            </div>
                                        </div>
                                    </div>
                                </template>
                                <!-- End Custome Pagination -->

                                <!-- Custome Pagination -->
                                <template slot="pagination-bottom" slot-scope="props">
                                    <div class="vgt-wrap__footer footer-pagination crm">
                                        <div  class="row">
                                            <div class="col-sm-12 col-md-2 PerPage">
                                                <v-select title="Select Per Page"
                                                    v-model="serverParams.perPage"
                                                    @change="changedValueTask"
                                                    @input="changedValueTaskCustomPerPageTask()"
                                                    name="customPerPage"
                                                    id="customPerPage"
                                                    label="text"
                                                    :clearable="false"
                                                    :searchable="false"
                                                    :filterable="false"
                                                    :options="serverParams.perPageDropdown"
                                                    placeholder="Select Per Page">
                                                </v-select>
                                            </div>
                                            <div class="mt-2 col-sm-12 col-md-2 RowsDisplay">
                                                <p class="pageRowCount">{{paginationDisplayRowsTask}} of {{totalRecords}}</p>
                                            </div>
                                            <div class="col-sm-12 col-md-6 Pagination">
                                                <ul class="pagination">
                                                    <li class="FirstPage" title="First Page">
                                                        <template v-if="Number(serverParams.page) == 1">
                                                            <a class="page-link" href="javascript:void(0)">1</a>
                                                        </template>
                                                        <template v-else>
                                                            <a v-on:click="onPerticularPageClickTask(1)" class="page-link" href="javascript:void(0)">1</a>
                                                        </template>
                                                    </li>
                                                    <li class="page-item PreviousPage" title="Previous Page">
                                                        <template v-if="Number(serverParams.page) == 1">
                                                            <a class="page-link" href="javascript:void(0)" tabindex="-1"><i class="fa fa-angle-left"></i></a>
                                                        </template>
                                                        <template v-else>
                                                            <a class="page-link" href="javascript:void(0)" tabindex="-1" v-on:click="onPerticularPageClickTask(Number(serverParams.page)-1)" ><i class="fa fa-angle-left"></i></a>
                                                        </template>
                                                    </li>
                                                    <!--New Implementation-->
                                                    <template v-if="pageNumberListTask() < displayPageTask">
                                                        <template v-for="(n, index) in pageNumberListTask()">
                                                            <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                                <a class="page-link" href="javascript:void(0)">
                                                                    {{n}}
                                                                </a>
                                                            </li>
                                                            <li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                                <a class="page-link" href="javascript:void(0)">
                                                                    {{n}}
                                                                </a>
                                                            </li>
                                                        </template>
                                                    </template>
                                                    <template v-else>
                                                        <!--End New Implementation-->
                                                        <template v-if="Number(serverParams.page) <= pageCompareTask">
                                                            <template v-for="(n, index) in displayPageTask">
                                                                <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                                    <a class="page-link" href="javascript:void(0)">
                                                                        {{n}}
                                                                    </a>
                                                                </li>
                                                                <li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                                    <a class="page-link" href="javascript:void(0)">
                                                                        {{n}}
                                                                    </a>
                                                                </li>
                                                            </template>
                                                        </template>
                                                        <template v-else-if="Number(serverParams.page) >= (pageNumberListTask() - (pageCompareTask-1))">
                                                            <template v-for="(n, index) in pageNumberListTask()">
                                                                <template v-if="n > (pageNumberListTask() - displayPageTask)">
                                                                    <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                                        <a class="page-link" href="javascript:void(0)">
                                                                            {{n}}
                                                                        </a>
                                                                    </li>
                                                                    <li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                                        <a class="page-link" href="javascript:void(0)">
                                                                            {{n}}
                                                                        </a>
                                                                    </li>
                                                                </template>
                                                            </template>
                                                        </template>
                                                        <template v-else>
                                                            <template v-for="(n, index) in pageNumberListTask()" v-if="(n >= (Number(serverParams.page) - (pageCompareTask -1))) && (n <= (Number(serverParams.page) + (pageCompareTask -1)))">
                                                                <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                                    <a class="page-link" href="javascript:void(0)">
                                                                        {{n}}
                                                                    </a>
                                                                </li>
                                                                <li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                                    <a class="page-link" href="javascript:void(0)">
                                                                        {{n}}
                                                                    </a>
                                                                </li>
                                                            </template>
                                                        </template>
                                                    </template>
                                                    <li class="page-item NextPage" title="Next Page">
                                                        <template v-if="Number(serverParams.page) == pageNumberListTask()">
                                                            <a class="page-link" href="javascript:void(0)"><i class="fa fa-angle-right"></i></a>
                                                        </template>
                                                        <template v-else>
                                                            <a class="page-link" href="javascript:void(0)" v-on:click="onPerticularPageClickTask(Number(serverParams.page)+1)"><i class="fa fa-angle-right"></i></a>
                                                        </template>
                                                    </li>
                                                    <li class="LastPage" title="Last Page">
                                                        <template v-if="Number(serverParams.page) == pageNumberListTask()">
                                                            <a class="page-link" href="javascript:void(0)" tabindex="-1">{{pageNumberListTask()}}</a>
                                                        </template>
                                                        <template v-else>
                                                            <a v-on:click="onPerticularPageClickTask(pageNumberListTask())" class="page-link" href="javascript:void(0)" tabindex="-1">{{pageNumberListTask()}}</a>
                                                        </template>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div class="mt-2 col-lg-1 col-md-1 col-sm-2 col-xs-6">
                                                <p class="pageJumpLabel">Page : </p>
                                            </div>
                                            <div class="mt-1 col-lg-1 col-md-1 col-sm-2 col-xs-6">
                                                <input @keyup.enter="jumpToPageInTask" v-model="jumpToPageTask" type="text" class="form-control form-control-sm" name="jumpToPageTask" id="jumpToPageTask" placeholder="Page">
                                            </div>
                                        </div>
                                    </div>
                                </template>
                                <!-- End Custome Pagination -->

                                <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                    <div :key="key">
                                        <!-- <template v-if="props.row.auditUserName != ''">
                                        </template>
                                        <template v-else> -->
                                        <div v-if="props.column.field == 'action'">
                                            <template v-if="props.formattedRow['part_no'] != 'Total'">
                                                <!-- <router-link class="btn edit-btn-vvg waves-effect" v-bind:to="{name: 'CustomerUseParts', query:{isEdit: 'No'}, params:{id:props.row.id, name: props.row.strip_part_no, isFrom: 'dashboard'}}">
                                                    <img src="/static/images/cart-img.png" alt="Shopping Cart" class="table-cart">
                                                </router-link> -->
                                                <!-- {{props.row.isEditable}} -->
                                                <template v-if="props.row.isEditable && !isViewOnly">
                                                    <router-link class="btn edit-btn-vvg waves-effect" title="Edit Part" v-bind:to="{name: 'CustomerUseParts', query:{isEdit: 'Yes'}, params:{id:props.row.id, name: props.row.strip_part_no, isFrom: 'dashboard', qty:props.row.inventory_qty, work_order: props.row.work_order, purchase_work_order: props.row.purchase_work_order, is_audited: props.row.isAudit}}">
                                                        <i class="fa fa-pencil" aria-hidden="true"></i>
                                                    </router-link>
                                                    <a v-if="props.row.isAudit != 1" class="btn edit-btn-vvg waves-effect" title="Delete Order History" v-on:click="deletePartsDepletionHistory(props.row.id)">
                                                        <i class="fa fa-trash-o" aria-hidden="true"></i>
                                                    </a>
                                                </template>
                                                <template v-else>
                                                    <!-- <a class="btn edit-btn-vvg waves-effect" title="Download Invoice" v-on:click="generatePdfToGetCustOrderInv(props.row.id)">
                                                        <img src="/static/images/pdf-icon.png" width="20px" height="20px">
                                                    </a> -->
                                                </template>
                                            </template>
                                        </div>
                                        <div v-else-if="props.column.field == 'invoice_no'">
                                            <p v-html="addNewLineInInovoiceColumn(props.formattedRow['invoice_no'])"></p>
                                        </div>
                                        <div v-else-if="props.column.field == 'invoice_date'">
                                            <p v-html="addNewLineInInovoiceColumn(props.formattedRow['invoice_date'])"></p>
                                        </div>
                                        <div v-else>
                                            {{props.formattedRow[props.column.field]}}
                                        </div>
                                        <!-- </template> -->
                                    </div>
                                </template>
                                <div slot="selected-row-actions" slot-scope="computed">
                                    {{computed.selectedRows}}
                                    <!--<button title='Mail' >Mail</button>-->
                                    <button v-on:click="deleteInventoryParts()" class="btn btn-success" title="Delete">Delete Inventory Part(s) ({{selectedRows}})</button>
                                </div>
                            </vue-good-table>
                        </div>
                        <!-- Contact Grid 2 -->
                    </div>
                </div>
      		</div>
      		<!--page content-->
    	</div>
    	<customer-footer></customer-footer>
  	</div>
  	<!-- Page Content Wrapper -->
</template>

<script>
    var self;
    import Vue from "vue";
    import CustomerFooter from "@/components/partials/CustomerFooter";
    import CustomerAuditInventoryList from "@/components/Customer/CustomerAuditInventoryList";
    import {commonMixins} from '../../mixins/commonMixins';
    import EventBus from "../event-bus";
    import {HTTP} from '../../http-common';
    import vSelect from 'vue-select';
    import moment from 'moment';
    import timezone from 'moment-timezone';
    //Vue.component("customer-footer", CustomerFooter);

    export default {
        components: {
            'customer-footer': CustomerFooter,
            'customer-audit-inventory': CustomerAuditInventoryList,
            'v-select': vSelect,
        },
        name: 'Dashboard',
        mixins: [commonMixins],
        data () {
            return {
                mySiteArr: [],
                customer_data:{
                    name:'',
                    excede_customer_id:'',
                    primary_email : '',
                    primary_contact : '',
                },
                recentHistoryData : [],
                columns: [
                    /*{
                        label: 'Id',
                        field: 'id',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Id", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },*/
                    /* {
                        label: 'Inventory',
                        field: 'inventory_name',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Inventory", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    }, */
                    {
                        label: 'Part',
                        field: 'part_no',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Part", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Is "CORE Part" included?',
                        field: 'is_core_part_available',
                        filterable: false,
                        sortable: false,
                    },
                    {
                        label: 'Description',
                        field: 'part_description',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Description", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
					{
                        label: 'QOH',
                        // field: 'inventory_qty',
                        field: 'qty_on_hand',
                        type: "number",
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "QOH", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Qty Used',
                        field: 'inventory_qty',
                        filterable: true,
                        type: "number",
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Qty Used", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
					},
                    {
                        label: 'BO Qty',
                        field: 'back_order_qty',
                        filterable: true,
                        type: "number",
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "BO Qty", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
					},
                    {
                        label: 'Unit Cost',
                        field: 'part_unit_price',
                        type: "number",
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Unit Cost", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    /* {
                        label: 'ExtCost',
                        field: 'part_ext_price',
                        type: "number",
                        filterable: false,
                        sortable: false,
                        thClass: 'disable-sorting',
                    }, */
                    {
                        label: "Work Order",
                        field: "work_order",
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Work Order", // placeholder for filter input
                            filterValue: "", // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: "PO Number",
                        field: "unique_po_number",
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "PO Number", // placeholder for filter input
                            filterValue: "", // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    /* {
                        label: 'Threshold Qty',
                        field: 'inventory_threshold_qty',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Threshold Qty", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    }, */
                    {
                        label: "Invoice No",
                        field: "invoice_no",
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Invoice No", // placeholder for filter input
                            filterValue: "", // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: "Invoice Date",
                        field: "invoice_date",
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "MM/DD/YYYY", // placeholder for filter input
                            filterValue: "", // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                      label: "Date",
                      field: "inv_created_at",
                      filterable: false,
                      sortable: false,
                      thClass: "disable-sorting",
                    },
                    {
                        label: "User Name",
                        field: "custName",
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "User Name", // placeholder for filter input
                            filterValue: "", // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: "Audit User Name",
                        field: "auditUserName",
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Audit User Name", // placeholder for filter input
                            filterValue: "", // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Action',
                        field: 'action',
                        sortable: false,
                        hidden: false,
                        thClass: 'disable-sorting',
                    }

                ],
                rows: [],
                totalRecords: 0,
                serverParams: {
                    columnFilters: {

                    },
                    sort: {
                        field: 'id',
                        type: 'desc',
                    },
                    page: 1,
                    perPage: 'All',
                    setCurrentPage: 1,
                    perPageDropdown : [],
                },
                selectedRows: 0,
                inventoryId : 0,
                displayPageTask: 7,
                jumpToPageTask: 0,
                pageCompareTask: 0,
                paginationDisplayRowsTask: '',
                date_picker_options: {
					range: true,
					onlyDate: true,
					outputFormat: 'YYYY-MM-DD',
					inputFormat: 'YYYY-MM-DD',
					formatted: 'MMM DD, YYYY',//'YYYY-MM-DD', 
					noClearButton: true,
					maxDate : '',
                  	// Getting error when using the for date picker options
                  	// 'no-shortcuts': false,
                  	customShortcuts : [
						{ key: 'yesterday', label: 'Yesterday', value: '-day', isSelected: true },
						{ key: 'thisWeek', label: 'This Week', value: 'isoWeek', isSelected: false },
						{ key: 'lastWeek', label: 'Last Week', value: '-isoWeek', isSelected: false },
						{ key: 'thisMonth', label: 'This Month', value: 'month', isSelected: false },
						{ key: 'lastMonth', label: 'Last Month', value: '-month', isSelected: false },
                        {
                            key: 'customValue',
                            label: 'YTD',
                            value: () => {
                                return {
                                    start: moment().startOf('year'),
                                    end: moment()
                                }
                            },
                            callback: ({ start, end }) => {
                                // console.log('My shortcut was clicked with values: ', start, end)
                            }
                        },
                  	]
                },
                date_picker_dates: "",
                totalQtyOnHand: 0,
				totalQty: 0,
				isShowDateRangePicker: false,
				totalExtCost: 0,
                isViewOnly: false
            }
        },
        beforeMount() {
            self = this;
            EventBus.$emit("customer-menu-selection-changed", "customer-cards");
        },
        mounted: function() {
            $(window).resize(function () {
                self.windowWidth = $(window).width();
                /* if (self.windowWidth > 767) {
                    $('.contacttDetails').hide();
                } else {
                    $('.contacttDetails').show();
                } */
                // $('.cl .admin-page-content.sticky .vgt-responsive').height($(window).height() - 390);
            });
            self.customerProtal();
			self.isShowDateRangePicker = false;
            if(localStorage.getItem("usingDateRangeFilters") === 'yes') {
              	self.isShowDateRangePicker = true;
            }
            self.date_picker_dates = {
              "start": moment().subtract(13, 'days'),
              "end": moment()
			};
            this.jumpToPageTask = this.serverParams.page;
            this.pageCompareTask = Math.ceil(this.displayPageTask / 2);
            $("#jumpToPageTask").on('keyup', function (e) {
                if (e.keyCode === 13) {  //checks whether the pressed key is "Enter"
                    self.jumpToInputPageTask(self.jumpToPageTask)
                }
            });

            this.serverParams.perPageDropdown.push(25);
            this.serverParams.perPageDropdown.push(50);
            this.serverParams.perPageDropdown.push(100);
            this.serverParams.perPageDropdown.push(200);
            this.serverParams.perPageDropdown.push(500);
            this.serverParams.perPageDropdown.push('All');

            if(localStorage.getItem("login_role") == 'user') {
                for(var i = 0; i < self.columns.length;i++) {
                    if (self.columns[i].field == "action") {
                        self.$set(self.columns[i], 'hidden', true);
                    }
                }
            }

            self.setActiveMenu('customer-cards');
            //console.log('customer_obj',JSON.parse(localStorage.getItem('customer_obj')));
            /* self.customer_data.name = JSON.parse(localStorage.getItem('customer_obj')).name;
            self.customer_data.excede_customer_id = JSON.parse(localStorage.getItem('customer_obj')).excede_customer_id;
            self.customer_data.primary_email = JSON.parse(localStorage.getItem('customer_obj')).primary_email;
            self.customer_data.primary_contact = JSON.parse(localStorage.getItem('customer_obj')).primary_contact; */
            // self.loadRecentOrders();
			self.loadInventoryParts(false);

            /* setTimeout(function(){
                var stickyTop12 = 77;
                $(window).scroll(function () {
                    var windowTop = $(window).scrollTop();
                    var el = $('.admin-page-content');
                    if (el.length > 0) {
                        if (stickyTop12 < windowTop && !el.is('.sticky') && $(el).outerHeight() > ($(window).height() - 235)) {
                            el.addClass('sticky');
                            $('.cl .admin-page-content.sticky .vgt-responsive').height($(window).height() - 390);
                            $('#page-content-wrapper').addClass('sticky-footer');
                        }
                        else if (stickyTop12 > windowTop && el.is('.sticky')) {
                            el.removeClass('sticky');
                            $('.cl .admin-page-content .vgt-responsive').removeAttr('style');
                            $('#page-content-wrapper').removeClass('sticky-footer');
                        }
                    }
                });
            },500); */
            self.isViewOnly = JSON.parse(localStorage.getItem('view_only'));
        },
        methods: {
            rowStyleClassFn: function(row) {
                if(row.isAudit && row.part_no != 'Total') {
                    return 'audit-user-parts';
                }
            },
            useParts: function() {
              	self.$router.push("/customer/use-parts");
            },
            changeDatePickerDate : function () {
              	// self.datePickerError = '';   
            },
            clearFilter(){
				self.date_picker_dates.start = '';
				self.date_picker_dates.end = '';
				self.loadInventoryParts(false);
            },
            jumpToPageInTask: function (e) {
                self.jumpToInputPageTask(self.jumpToPageTask);
            },
            changedValueTaskCustomPerPageTask: function () {
                self.jumpToInputPageTask(self.serverParams.page);
                self.loadInventoryParts(false);
            },
            changedValueTask: function (value) {
                /*console.log(value);*/
            },
            pageNumberListTask: function () {
                var totalRecord = self.totalRecords;
                var count = 0;
                for (var i = 0; totalRecord > 0; i++) {
                    totalRecord = totalRecord - self.serverParams.perPage;
                    count++;
                }
                return count;
            },
            jumpToInputPageTask: function (pageNumber) {
                var reg = /^\d+$/;
                if (pageNumber <= 0 || pageNumber == '') {
                    pageNumber = 1;
                } else if (pageNumber > self.pageNumberListTask()) {
                    pageNumber = self.pageNumberListTask();
                    if (pageNumber <= 0 || pageNumber == '') {
                        pageNumber = 1;
                    }
                } else if (!String(self.jumpToPageTask).match(reg)) {
                    pageNumber = 1;
                }
                self.onPerticularPageClickTask(pageNumber);
            },
            onPerticularPageClickTask: function (pageNumber) {
                self.serverParams.page = pageNumber;
                self.jumpToPageTask = pageNumber;
                self.loadInventoryParts(false);
            },
            deletePartsDepletionHistory : function(id) {
                var self = this;
                var inventoryPartArr = [];
                var config = {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("api_token")
                    },
                };
                var fields = {
                    id: id
                };
                self.$swal({
                    title: "Are you sure?",
                    text: "You can't revert your action",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonText: "Yes Delete it!",
                    cancelButtonText: "No, Keep it!",
                    showCloseButton: true,
                    showLoaderOnConfirm: true
                }).then(result => {
                        if (result.value) {
                            HTTP.post("customer/recent-parts-deplation/delete", fields, config)
                                .then(function(response) {
                                    self.loadInventoryParts(false);
                                })
                                .catch(function(err) {
                                    if (err.response.status == 0) {
                                        self.error = "Remote server can not be reachable";
                                    } else {
                                        //redirect to login page if user not authenticated
                                        if (err.response.status == 401) {
                                            //clear previous data
                                            localStorage.removeItem("user_obj");
                                            localStorage.removeItem("api_token");
                                            localStorage.removeItem("profile_image");
                                            //self.$router.push("/login");
                                            //EventBus.$emit("logged-in", true, "", "");
                                        }
                                    }
                                });
                            self.$swal("Deleted", "You successfully deleted order history(s)", "success");
                        }
                	});
            },
            editPart : function (inventoryId, id) {
                var self = this;
                self.$router.push("/customer/list-inventory/" + inventoryId +"/update-inventory-part/" + id + '/dashboard');
            },
            loadInventoryParts: function (isExport) {
                var self = this;
                self.firstLoad = 1;
                self.totalQtyOnHand = 0;
                self.totalQty = 0;
                self.totalExtCost = 0;
                if (self.date_picker_dates.end === null) {
                  	self.date_picker_dates.end = self.date_picker_dates.start;
				}
				var fromDate = "";
				var toDate = "";
				// if(self.isShowDateRangePicker) {
					fromDate = self.date_picker_dates.start != "" ? moment(self.date_picker_dates.start).format("YYYY-MM-DD") : "";
                    toDate = self.date_picker_dates.start != "" ? moment(self.date_picker_dates.end).format("YYYY-MM-DD") : "";
                // }
                var customerId = 0;
                if(localStorage.getItem("login_role") == 'user') {
                    customerId = localStorage.getItem("customer_id");
                } else {
                    customerId = JSON.parse(localStorage.getItem('customer_obj')).id
                }

                var config = {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("api_token")
                    },
                    params:{
                        page:self.serverParams.page,
                        perPage:self.serverParams.perPage,
                        filters:self.serverParams.columnFilters,
                        sort:self.serverParams.sort,
                        // inventory_id : self.inventoryId,
                        from_date: fromDate,
                        to_date: toDate,
                        tz: moment.tz.guess(),
                        isExport: isExport,
                        isShowDateRangePicker: self.isShowDateRangePicker,
                        cureentDate: moment().format("YYYY-MM-DD"),
                        customer_id: customerId
                    }
                };
                // HTTP.get("customer/inventory/list-inventory-parts", config)
                HTTP.get("customer/recent-parts-deplation", config)
                    .then(function (data) {
                        if (data.status == 200) {
							if(data.data.message == "success export") {
								location.href = data.data.content;
							} else {
								self.rows = [];
								self.rows = data.data.content.row;
								self.totalRecords = data.data.content.totalRecords;
								self.inventoryHeader = data.data.content.row[0].inventory_name;
								self.paginationDisplayRowsTask = self.getRecords(self.serverParams.page, self.serverParams.perPage, self.totalRecords);
								if(self.rows && self.rows.length > 0) {
                                    self.totalQty = 0;
									for (let index = 0; index < self.rows.length; index++) {
										var element = self.rows[index];
										if(element.inventory_part_max_qty > 0) {
											self.totalQtyOnHand += element.inventory_part_max_qty;
										}
										if(element.inventory_qty > 0) {
											self.totalQty += element.inventory_qty;
										}
									}
									self.totalExtCost = data.data.content.partExtCostTotal;
									self.rows.push({
										part_no: "Total",
										inventory_part_max_qty: self.totalQtyOnHand,
										inventory_qty: self.totalQty,
										part_unit_price: data.data.content.unitCostTotal,
										// part_ext_price: data.data.content.partExtCostTotal,
										inv_updated_at: '',
									});
								}
							}
                        }
                    })
                    .catch(function (error) {
                        //self.catchHandler(error);
                    })
                   /*  setTimeout(function () {
                        var child = document.querySelectorAll("div.vgt-responsive")[0];
                        var formTr = child.querySelectorAll("tbody tr td div")[0].attributes[0].ownerDocument.body;
                        // var formTr = child.querySelectorAll("tr td div")[0].attributes[0].ownerDocument.body.innerText;
                        console.log(formTr);
                    }, 1500);  */
                    
            },
            onPageChange(params) {
                this.updateParams({page: params.currentPage});
                self.loadInventoryParts(false);
            },
            updateParams(newProps) {
                this.serverParams = Object.assign({}, this.serverParams, newProps);
            },
            onPerPageChange(params) {
                this.updateParams({perPage: params.currentPerPage});
                this.totalRecords = self.totalRecords;
                self.loadInventoryParts(false);
            },
            selectionChanged() {
                var self = this;
                self.selectedRows = self.$refs["listInventoryPartsTable"].selectedRows.length;
            },

            onColumnFilter(params) {
                this.updateParams(params);
                {
                    field: ('id');
                    field: ('part_name');
                    field: ('qty_on_hand');
                    field: ('inventory_qty');
                    field: ('part_unit_price');
                    field: ('work_order');
                };
                this.serverParams.page = 1;
                var filtersPr = JSON.parse(JSON.stringify(this.serverParams));
                var filters = filtersPr.columnFilters;
                if (self.firstLoad == 1 || filters.id || filters.part_name || filters.qty_on_hand || filters.inventory_qty || filters.part_unit_price || filters.work_order) {
                    self.loadInventoryParts(false);
                }
            },
            onSortChange(params) {
                this.updateParams({
                    sort: {
                        type: params[0].type,
                        field: params[0].field,
                    },
                });
                self.loadInventoryParts(false);
            },
            loadRecentOrders: function () {
                var self = this;
                var config = {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("api_token")
                    },
                };
                HTTP.get("customer/recent-parts-deplation", config)
                    .then(function (data) {
                        if (data.status == 200) {
                            self.recentHistoryData = data.data.content;
                        }
                    })
                    .catch(function (error) {
                        //self.catchHandler(error);
                    })
            },
        },
    }
    EventBus.$on("change-customer-dropdown-value", function(data) {
        if (typeof self != "undefined") {
            self.loadInventoryParts(false);
        }
    });
</script>
<style scoped>
  	th.filter-th:nth-child(2) input::placeholder, th.filter-th:nth-child(3) input::placeholder {
    	text-align: right !important;
  	}
  	.admin-content-area .page-header-top-container .page-name {
    	margin-bottom: 15px !important;
  	}
  	.field-input { font-size:13px !important;}
  	.field.has-value .field-label { top:-2px !important;}
</style>


// WEBPACK FOOTER //
// src/components/Customer/CustomerOrderHistory.vue